import { Badge, BadgeProps, MantineColor } from '@mantine/core';
import * as React from 'react';

type BaseBadgeProps = {
  className?: string;
  color: MantineColor;
  children: React.ReactNode;
  size?: BadgeProps['size'];
};

const BaseBadge: React.FC<BaseBadgeProps> = ({ className, color, children, size = 'xs' }) => {
  return (
    <Badge className={className} color={color} radius="sm" size={size} tt="inherit" fw={400}>
      {children}
    </Badge>
  );
};

export default React.memo(BaseBadge);
